import React from 'react';

function BuyModal({ product, onClose }) {
  if (!product) return null;

  const whatsappNumber = '919217543325';
  const whatsappMessage = `Hi, I want to buy ${product.name}. I saw your lowest price of ₹${product.price}.`;
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Buy {product.name}</h2>

        <div className="contact-links">

          {/* ⭐ WhatsApp */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noreferrer"
            className="whatsapp-focus"
          >
            <span className="whatsapp-main">💬 WhatsApp: +91 98765 43210</span>
            <span className="whatsapp-sub">
              🔥 Lowest Price: ₹{product.price}
            </span>
          </a>
          
          {/* Amazon */}
          {product.links?.amazon && (
            <a
              href={product.links.amazon}
              target="_blank"
              rel="noreferrer"
              className="contact-btn amazon"
            >
              🛒 Amazon
            </a>
          )}

          {/* Flipkart */}
          {product.links?.flipkart && (
            <a
              href={product.links.flipkart}
              target="_blank"
              rel="noreferrer"
              className="contact-btn flipkart"
            >
              🛍️ Flipkart
            </a>
          )}

          {/* Instagram */}
          {product.links?.instagram && (
            <a
              href={product.links.instagram}
              target="_blank"
              rel="noreferrer"
              className="contact-btn instagram"
            >
              📸 Instagram
            </a>
          )}
        </div>

        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default BuyModal;
